import { render, staticRenderFns } from "./call-records-table.vue?vue&type=template&id=73fc7990&scoped=true&"
import script from "./call-records-table.vue?vue&type=script&lang=js&"
export * from "./call-records-table.vue?vue&type=script&lang=js&"
import style0 from "./call-records-table.vue?vue&type=style&index=0&id=73fc7990&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fc7990",
  null
  
)

export default component.exports